<template><div id="wrap">
  <div id="app" class="w-screen h-ipad bg-black text-white antialiased flex flex-col items-center text-base">
    <NavBar />

    <router-view></router-view>

    <Footer />
  </div></div>
</template>

<script>


window.onload = function() {
  document.getElementById('wrap').className = 'loaded';
};

import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: 'app',
  components: {
    NavBar, Footer
  }
}


</script>

<style>
/* Base Configuration Styles are shared across multiple pages */

body {
  background-color: #000000;
}


/* universal styles */

.button {
  display: inline-block;
  text-transform: uppercase;
  margin:1rem 0;
  color: white;
  border: 1px solid white;
  text-decoration: none;
  padding: 1rem;
}

.button:hover {
  background-color: #fff;
  color: #000;
}



#wrap {
  opacity: 0;
  transition: opacity 0.75s ease-in;
}

#wrap.loaded{
  opacity:1;

}


</style>
